<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="title"><em class="italic">Debbie Shore’s</em></h1>
<h1 class="title1c">SEWING ROOM SECRETS</h1>
<h1 class="title1"><span class="bold">Quilting</span></h1>
<p class="subheading2">Top tips and techniques for successful sewing</p>
<div class="img_containerr">
<img alt="images" src="images/pub.jpg"/>
</div>
<div class="img_container">
<img alt="Image" src="images/title.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?b09c3024